import { Link, MenuItem, styled } from '@mui/material';
import { useState } from 'react';
import { Content } from '../color';
import { TypographyStyles } from '../typography';

export { default as Dropdown } from '@mui/material/Menu';

export const DropdownAnchor = styled(Link)(({ theme }) => ({
  ...TypographyStyles.link2,
  padding: `${theme.spacing(1.5)} ${theme.spacing(4)}`,
  width: '100%',
  textDecoration: 'none',
  color: Content.main,
  '&:visited': {
    textDecoration: 'none',
    color: Content.main,
  },
}));

export const DropdownItem = styled(MenuItem)(() => ({
  padding: 0,
}));

export const useDropdownControls = (onClick?: (event: React.MouseEvent<HTMLElement>) => void): [
  null | HTMLElement,
  (event: React.MouseEvent<HTMLElement>) => void,
  () => void,
] => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);

    if (onClick) {
      onClick(event);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return [anchorEl, handleOpen, handleClose];
};
